import { createContext } from 'react';
var MenuContext = /*#__PURE__*/createContext({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false
});
export default MenuContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components/node_modules/kts-components-antd-x4/es/menu/MenuContext.js
// module id = 1463
// module chunks = 0